import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("atrocity-cookie-consent")) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem("atrocity-cookie-consent", value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:left-6 sm:max-w-md z-50 border border-blooddeep/50 bg-pulp p-6 ink-shadow"
        >
          <span className="inline-block bg-blooddeep text-white font-marker text-xs px-3 py-1 -rotate-2 mb-4 ink-shadow-sm">
            COOKIES — THE DIGITAL KIND
          </span>
          <div className="flex items-start gap-3 mb-5">
            <Cookie size={22} className="text-crimson shrink-0 mt-0.5" />
            <p className="font-type text-sm text-paper/70 leading-relaxed">
              We use browser cookies to remember your age verification, your cart, and this very
              choice. No third-party trackers lurk here. Choose your fate.
            </p>
          </div>
          <div className="flex gap-3">
            <button
              data-testid="cookie-accept-button"
              onClick={() => choose("accepted")}
              className="flex-1 font-impact uppercase tracking-wider text-sm bg-blooddeep text-bone border-2 border-black px-5 py-3 ink-shadow-sm crimson-glow transition-all duration-150 hover:bg-crimson hover:-translate-y-0.5 active:translate-x-0.5 active:translate-y-0.5"
            >
              Accept
            </button>
            <button
              data-testid="cookie-deny-button"
              onClick={() => choose("denied")}
              className="flex-1 font-impact uppercase tracking-wider text-sm bg-transparent text-paper border-2 border-paper/40 px-5 py-3 transition-colors duration-150 hover:border-bloodglow hover:text-bloodglow"
            >
              Deny
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
